import { serviceGo } from "@/utils/request";
import {ChatMessage} from "@/api/chat";

export interface TalkMsg{
    text: string
}

export async function getTalk(b64: string): Promise<{res: TalkMsg}> {
  const res = await serviceGo.post(`/api_v2/asr/oneshot`, {
        audio_base64: b64,
        voice_format: 'wav',   // 后端若做转码请填 'wav'；若直接透传webm需在后端转码
        engine_type: '16k_zh', // 你也可以按需切换 '16k_en' 等
      })
  return res.data
}

